//import store from '@/store/index';
import axios from 'axios';
import store from '../store';
export default function setInterceptors(that) {
    //var that = this;
    axios.interceptors.request.use(function(config){

        const token = window.store.getters['auth/data'];
        if(token) {
            if(config.url.indexOf("/api/public/emp/auth?") > -1){

                window.store.dispatch("auth/removeAuth")
            }else{

                config.headers.Authorization = token;
                config.headers['X-AUTH-TOKEN'] = token;
            }
        }
        return config;
    }, function(err){
        return Promise.reject(err);
    });

    axios.interceptors.response.use(function(response){

        if(response.data.statusCode == 500){
            // vue.$toast.error(response.data.message);
            vue.noti('서버오류', response.data.message, 'danger');
            throw new Error(response.data.message);
        }
        return response;
    }.bind(this), function(err){
        return Promise.reject(err);
    });
}
